<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 20V12.4L6 7.4V10H4V4H10V6H7.4L13 11.6V20H11ZM14.85 10.6L13.4 9.15L16.6 6H14V4H20V10H18V7.4L14.85 10.6Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
